import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import {
  useCfopMutation,
  useCfops,
} from '@/core/domain/invoice/cfop/Cfop.hooks';
import { SearchCfopsQuery } from '@/core/domain/invoice/cfop/Cfop.types';
import useSelectOptions from '@/hooks/useSelectOptions';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: SearchCfopsQuery;
  queryEnable?: boolean;
};

const codesDisabled = ['5404', '1405'];

const CfopSelectField: React.FC<Props> = ({
  queryFilter,
  queryEnable = false,
  ...props
}) => {
  const [selectClicked, setSelectClicked] = useState<boolean>(false);

  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const cfopsList = useCfops(
    {
      rows: 10,
      description: search,
      ...queryFilter,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );

  const cfopDetail = useCfopMutation();

  const options = useSelectOptions({
    list: cfopsList,
    detail: cfopDetail,
    selectProps: props,
    labelFormatter: (cfop) => `${cfop.code} - ${cfop.description}`,
    disableCondition: (cfop) => codesDisabled.includes(cfop.code),
  });

  return (
    <InfiniteSelect
      fetchNextPage={cfopsList.fetchNextPage}
      hasNextPage={cfopsList.hasNextPage}
      loading={cfopsList.isLoading}
      options={options}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      allowClear
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      {...props}
    />
  );
};

export default CfopSelectField;
